import { render, staticRenderFns } from "./ReplaceNotificationAlert.vue?vue&type=template&id=5f0d1b82&scoped=true&"
import script from "./ReplaceNotificationAlert.vue?vue&type=script&lang=js&"
export * from "./ReplaceNotificationAlert.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceNotificationAlert.vue?vue&type=style&index=0&id=5f0d1b82&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d1b82",
  null
  
)

/* custom blocks */
import block0 from "./ReplaceNotificationAlert.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0d1b82')) {
      api.createRecord('5f0d1b82', component.options)
    } else {
      api.reload('5f0d1b82', component.options)
    }
    module.hot.accept("./ReplaceNotificationAlert.vue?vue&type=template&id=5f0d1b82&scoped=true&", function () {
      api.rerender('5f0d1b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/FlyScanView/ReplaceNotificationAlert.vue"
export default component.exports